
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FloatingMenuPlugin } from '@tiptap/extension-floating-menu';
import { Editor } from '@tiptap/core';
import { TipTapEditorContext } from '@/components/tiptap/types';

const FLOATING_MENU_PLUGIN_KEY = 'floatingMenu';

@Component
export default class FloatingMenu extends Vue {
  @Prop({ required: true }) editor: Editor;
  @Prop({ required: true }) editorContext: TipTapEditorContext;

  mounted() {
    const element = this.$refs.menu as HTMLElement;
    element.style.visibility = 'hidden';
    element.remove();

    this.editor.registerPlugin(
      FloatingMenuPlugin({
        pluginKey: FLOATING_MENU_PLUGIN_KEY,
        editor: this.editor,
        element,
        options: { placement: 'top-start', offset: { mainAxis: 8 }, flip: true, shift: { padding: 8 } },
      })
    );
  }

  beforeDestroy() {
    this.editor.unregisterPlugin(FLOATING_MENU_PLUGIN_KEY);
  }
}
